module.exports = __webpack_public_path__ + "img/choose-icon02.522ed1b0.png";